export const REPORT_REASONS = Object.freeze([
  Object.freeze({ value: "misinformation", label: "Misinformation" }),
  Object.freeze({ value: "spam_or_scam", label: "Spam or scam" }),
  Object.freeze({ value: "harassment", label: "Harassment" }),
  Object.freeze({ value: "off_topic", label: "Off topic" }),
]);
